<p *ngIf="text">
    <span [innerHTML]="text"><br /><br/></span>
</p>
